import { Reducer } from 'redux';
import {
  BrokerRateActionTypes,
  BrokerRateState,
  DELETE_BROKER_RATE,
  GET_ALL_BROKER_RATES,
  GET_BROKER_RATE,
  GET_BROKER_RATES_LIST,
  POST_BROKER_RATE,
  PUT_BROKER_RATE,
  UPDATE_BROKER_RATE_FILTERS
} from '../types/brokerrate.types';

const initialState: BrokerRateState = {
  brokerRates: [],
  brokerRatesStatistics: [],
  selectedBrokerRate: null,
  postSuccess: null,
  lastFetch: null,
  totalElements: 0,
  totalPages: 1,
  filters: null
};

export const brokerRateReducer: Reducer<BrokerRateState> = (
  state: BrokerRateState = initialState, action
) => {
  const timeOfAction = new Date().getTime();

  switch ((action as BrokerRateActionTypes).type) {
    case GET_BROKER_RATES_LIST:
      return {
        ...state,
        brokerRates: action.payload.page.content,
        selectedBrokerRate: null,
        postSuccess: null,
        lastFetch: timeOfAction,
        totalPages: action.payload.page.totalPages,
        totalElements: action.payload.page.totalElements
      };
    case GET_BROKER_RATE:
      return {
        ...state,
        postSuccess: null,
        selectedBrokerRate: action.payload.selectedBrokerRate,
        lastFetch: timeOfAction
      };
    case POST_BROKER_RATE:
      return {
        ...state,
        postSuccess: true,
        selectedBrokerRate: action.payload.newBrokerRate,
        lastFetch: timeOfAction
      };
    case PUT_BROKER_RATE:
      return {
        ...state,
        selectedBrokerRate: action.payload.selectedBrokerRate,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    case DELETE_BROKER_RATE:
      return {
        ...state,
        selectedCarModel: null,
        lastFetch: timeOfAction
      };
    case UPDATE_BROKER_RATE_FILTERS:
      return {
        ...state,
        filters: action.payload.filters
      };
    case GET_ALL_BROKER_RATES:
      return {
        ...state,
        brokerRates: action.payload.brokerRates
      };
    default:

      return state;
  }
};
